
<!-- 
SendMsgModal.vue
功能：發送訊息視窗(生日優禮&EDM)
作者：i9400538 陳博承
完成：2022-01-21
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content" :class="{'section-loading': sendLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">{{actionName}}</h3>
        </div>
        <!-- 初始區塊 -->
        <div v-if="type=='1'">
          <h4 class="padding-left-40">請選擇要發送的方式</h4>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="sendEmail">發送Email</button>
            <button type="button" class="btn btn-primary" @click="sendMsg">發送簡訊(手機)</button>
          </div>
        </div>
        <!-- 檢核訊息區塊 -->
        <!-- email -->
        <div v-if="type=='2' && emailCheck">
          <br />
          <label class="text-red padding-left-40">下列客戶不符合發送規則或無Email，故本次不發送{{actionName}}</label>
          <br />
          <br />
          <label class="padding-left-40">{{emailMsg}}</label>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="submit">確認</button>
          </div>
        </div>
        <!-- 簡訊 -->
        <div v-if="type=='2' && mobileCheck">
          <br />
          <label class="text-red padding-left-40">下列客戶不符合發送規則或無手機號碼，故本次不發送{{actionName}}</label>
          <br />
          <br />
          <label class="padding-left-40">{{mobileMsg}}</label>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="submit">確認</button>
          </div>
        </div>
        <!-- 今日已發送過 -->
        <div v-if="type=='3'">
          <br />
          <label class="text-red padding-left-40">提醒您，下列客戶本日已經發送過了呦!避免過度打擾客戶，明天再發送吧</label>
          <br />
          <br />
          <label class="padding-left-40">{{hasSendMsg}}</label>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="$emit('sendMsgSubmit')">確定</button>
          </div>
        </div>
        <!-- 完成區塊 -->
        <div v-if="type=='4'">
          <br />
          <label class="padding-left-40">發送完成!</label>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="$emit('sendMsgSubmit')">確定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//service
import { doSendMsg, doSendMail } from "@/service";
export default {
  name: "SendMsgModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    actionName: {
      type: String,
      default: ""
    },
    cust: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      type: "1",
      action: "", //發送API類型 (1:email / 2:簡訊)
      emailCheck: false, //email檢查
      mobileCheck: false, //發送簡訊檢查
      emailMsg: "", //不符合發送email的訊息
      mobileMsg: "", //不符合發送簡訊的訊息
      hasSendMsg: "", //今日已發送過的客戶訊息
      sendLoading: false,
      sendCust: []
    };
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.type = "1";
      this.emailCheck = false;
      this.mobileCheck = false;
      this.emailMsg = "";
      this.mobileMsg = "";
      this.hasSendMsg = "";
      this.sendLoading = false;
    },
    //發送email
    sendEmail() {
      this.emailMsg = "";
      this.sendCust = [];
      this.cust.forEach(item => {
        if (!item.isShow_B || !item.email) {
          this.emailMsg += "「" + item.name + "」、";
        } else {
          this.sendCust.push(item);
        }
      });
      if (this.emailMsg) {
        this.type = "2";
        this.emailMsg = this.emailMsg.substr(0, this.emailMsg.length - 1);
        this.emailCheck = true;
      } else {
        //通過檢查，開始發送API
        this.action = "1";
        this.submit();
      }
    },
    //發送簡訊
    sendMsg() {
      this.mobileMsg = "";
      this.sendCust = [];
      this.cust.forEach(item => {
        if (!item.isShow_M || !item.mobile) {
          this.mobileMsg += "「" + item.name + "」、";
        } else {
          this.sendCust.push(item);
        }
      });
      if (this.mobileMsg) {
        this.mobileMsg = this.mobileMsg.substr(0, this.mobileMsg.length - 1);
        this.mobileCheck = true;
        this.type = "2";
      } else {
        //通過檢查，開始發送API
        this.action = "2";
        this.submit();
      }
    },
    //確認
    submit() {
      if (this.sendCust && this.sendCust.length) {
        this.sendLoading = true;
        if (this.action == "1") {
          //寄發Email
          doSendMail(this.$store.state.userInfo.id, this.sendCust).then(
            result => {
              this.sendLoading = false;
              if (result.header && result.header.status === "200") {
                this.checkHasSendList(result);
              } else {
                this.setToastMsg("發送失敗 : " + result.header.message);
              }
            }
          );
        } else {
          //寄發簡訊
          doSendMsg(this.$store.state.userInfo.id, this.sendCust).then(
            result => {
              this.sendLoading = false;
              if (result.header && result.header.status === "200") {
                this.checkHasSendList(result);
              } else {
                this.setToastMsg("發送失敗 : " + result.header.message);
              }
            }
          );
        }
      } else {
        //沒有符合可寄發的資料
        this.$emit("sendMsgSubmit");
      }
    },
    //確認當天已寄送名單
    checkHasSendList(result) {
      if (result && result.body && !result.body.has_send_list) {
        this.type = "4";
        this.setToastMsg(result.header.message);
        return;
      }
      this.hasSendMsg = "";
      let hasSendList = result.body.has_send_list || [];
      this.cust.forEach(item => {
        if (hasSendList.includes(item.id)) {
          this.hasSendMsg += "「" + item.name + "」、";
        }
      });
      this.hasSendMsg = this.hasSendMsg.substr(0, this.hasSendMsg.length - 1);
      this.type = "3";
      this.setToastMsg(result.header.message);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.padding-left-40 {
  padding-left: 40px;
}
.input-txt {
  border: 1px solid #c2c4c7;
  border-radius: 4px;
}
</style>